import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';
import { HeaderComponent } from '../header/header.component';
import { OnboardingWizardService } from '../../services/onboarding-wizard/onboarding-wizard.service';

@Component({
    selector: 'app-contract-acknowledgment',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        HeaderComponent,
    ],
    templateUrl: './contract-acknowledgment.component.html',
    styleUrl: './contract-acknowledgment.component.scss',
})
export class ContractAcknowledgmentComponent implements OnInit {
    acknowledged = false;
    companyName = '';
    clientAddressLines: string[] = [];
    services: { service: string; feeWin: number | null; feeLoss: number | null }[] = [];
    isLoading = true;
    isSaving = false;
    loadError = '';

    private merchantOnboardingId: number | null = null;

    constructor(
        public utilities: UtilitiesService,
        private onboardingService: OnboardingWizardService,
        private route: ActivatedRoute,
    ) {
        this.utilities.isfullPage = true;
    }

    ngOnInit(): void {
        this.utilities.showLogo = true;
        this.companyName = this.utilities.companyNameValue || '';

        const fdcid = +(this.route.snapshot.queryParams['fdcid'] || 0);
        if (fdcid) {
            this.utilities.clientId = fdcid;
        }

        this.onboardingService.showContractWooCommerce().subscribe({
            next: (res: any) => {
                if (!res.result) {
                    this.utilities.redirectToDefaultURL();
                    return;
                }
                this.loadContractDetails();
            },
            error: () => {
                this.utilities.redirectToDefaultURL();
            }
        });
    }

    private loadContractDetails(): void {
        this.onboardingService.getContractDetailsWooCommerce().subscribe({
            next: (res: any) => {
                const result = res.result ?? res;

                this.merchantOnboardingId = result.onboardingId ?? result.onboarding_id ?? null;
                this.services = result.services ?? [];

                const client = result.clientDetails;
                if (client) {
                    this.companyName = client.companyName || this.companyName;
                    this.clientAddressLines = [];
                    if (client.address1) this.clientAddressLines.push(client.address1.trim());
                    if (client.address2) this.clientAddressLines.push(client.address2.trim());
                    const cityState = [client.city, client.state].filter(Boolean).join(' ').trim();
                    const thirdLine = [cityState, client.postalCode, client.country].filter(Boolean).join(', ');
                    if (thirdLine) this.clientAddressLines.push(thirdLine);
                }

                this.isLoading = false;
            },
            error: (err) => {
                console.error('[ContractAcknowledgment] failed to load contract details:', err);
                this.loadError = err?.error?.message || err?.message || 'Failed to load contract details.';
                this.isLoading = false;
            }
        });
    }

    save(): void {
        console.log('[ContractAcknowledgment] save() — acknowledged:', this.acknowledged, 'merchantOnboardingId:', this.merchantOnboardingId, 'isSaving:', this.isSaving);
        if (!this.acknowledged || !this.merchantOnboardingId || this.isSaving) return;

        this.isSaving = true;
        this.onboardingService.acceptContractWooCommerce(this.merchantOnboardingId).subscribe({
            next: () => {
                this.utilities.redirectToDefaultURL();
            },
            error: (err) => {
                console.error('[ContractAcknowledgment] failed to accept contract:', err);
                this.isSaving = false;
            }
        });
    }
}
